<div class="card4  p-1 ">

    <div class="p-1">
        <div class="size15">Valeur unitaire en stock</div>
        <div class=" size24">{{ formatPrice(valeurUnitaire) }} TND</div>
    </div>
</div>
